export const gender = [
  { id: "bd5a224c-fc69-11e8-92d8-000c290b6677", text: "Male" },
  { id: "ccc7faa0-fc69-11e8-92d8-000c290b6677", text: "Female" },
  { id: "c7f21630-2480-11e9-aabd-70106fbef856", text: "Prefer not to say" },
];

export const noticePeriod = [
  { id: 15, text: "15 Days" },
  { id: 30, text: "30 Days" },
  { id: 45, text: "45 Days" },
  { id: 0, text: "Serving notice period" },
  { id: 1, text: "Immediately available" },
  { id: 60, text: "2 Months" },
  { id: 90, text: "3 Months" },
  { id: 180, text: "6 Months" },
];

export const employmentType = [
  { id: "f583b140-fc6b-11e8-92d8-000c290b6677", text: "Full time" },
  { id: "00d78ad2-fc6c-11e8-92d8-000c290b6677", text: "Part time" },
  { id: "1a9600f6-fc6c-11e8-92d8-000c290b6677", text: "Correspondence" },
];

export const lookingFor = [
  { id: 1, text: "Internship" },
  { id: 2, text: "Jobs" },
  { id: 3, text: "Any of the two" },
];

export const percentage = [
  { id: 40, name: "< 40%" },
  { id: 44.9, name: "40%-44.9%" },
  { id: 49.9, name: "45%-49.9%" },
  { id: 54.9, name: "50%-54.9%" },
  { id: 59.9, name: "55%-59.9%" },
  { id: 64.9, name: "60-64.9%" },
  { id: 69.9, name: "65-69.9%" },
  { id: 74.9, name: "70-74.9%" },
  { id: 79.9, name: "75-79.9%" },
  { id: 84.9, name: "80-84.9%" },
  { id: 89.9, name: "85-89.9%" },
  { id: 94.9, name: "90-94.9%" },
  { id: 99.9, name: "95-99.9%" },
  { id: 100, name: "100%" },
];
